import { create } from 'zustand';
import { SETTINGS_DEFAULT, type GameSettings } from '@/types';

interface MetaStoreState {
  settings: GameSettings;

  /** Tamper detectado. Dispara CosmicGameOver. */
  cosmicGameOverActivo: boolean;
  cosmicGameOverRazon: string | null;

  /** Muerte en narrativa (vida → 0). Dispara la pantalla de Game Over. */
  gameOverMuerteActivo: boolean;

  /** Flag para suprimir el disparo de Game Over mientras hay un CombatScreen
   *  montado: el combat tiene su propia UI de derrota y al salir navega a
   *  `onDerrota`, que suele tener un `onEnter` que cura. Evitamos un doble
   *  game-over simultáneo. */
  combateActivo: boolean;

  panelLateralAbierto: boolean;

  setSettings: (parcial: Partial<GameSettings>) => void;
  dispararCosmicGameOver: (razon: string) => void;
  limpiarCosmicGameOver: () => void;
  dispararGameOverMuerte: () => void;
  limpiarGameOverMuerte: () => void;
  setCombateActivo: (v: boolean) => void;
  togglePanelLateral: () => void;
}

const STORAGE_KEY = 'tck_settings_v1';

function cargarSettings(): GameSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...SETTINGS_DEFAULT };
    const parsed = JSON.parse(raw) as Partial<GameSettings>;
    return { ...SETTINGS_DEFAULT, ...parsed };
  } catch {
    return { ...SETTINGS_DEFAULT };
  }
}

function persistirSettings(s: GameSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    // noop
  }
}

export const useMetaStore = create<MetaStoreState>((set, get) => ({
  settings: cargarSettings(),
  cosmicGameOverActivo: false,
  cosmicGameOverRazon: null,
  gameOverMuerteActivo: false,
  combateActivo: false,
  panelLateralAbierto: false,

  setSettings: (parcial) => {
    const nuevo = { ...get().settings, ...parcial };
    set({ settings: nuevo });
    persistirSettings(nuevo);
  },

  dispararCosmicGameOver: (razon) => {
    set({ cosmicGameOverActivo: true, cosmicGameOverRazon: razon });
  },
  limpiarCosmicGameOver: () => {
    set({ cosmicGameOverActivo: false, cosmicGameOverRazon: null });
  },

  dispararGameOverMuerte: () => {
    if (get().combateActivo) return; // el combat maneja su propia UI
    set({ gameOverMuerteActivo: true });
  },
  limpiarGameOverMuerte: () => {
    set({ gameOverMuerteActivo: false });
  },

  setCombateActivo: (v) => set({ combateActivo: v }),

  togglePanelLateral: () => {
    set((s) => ({ panelLateralAbierto: !s.panelLateralAbierto }));
  },
}));
